import React, { useEffect } from "react";

function AdsBootstrapper() {
  useEffect(() => {
    let attempts = 0;

    const interval = setInterval(() => {
      const isDigitalSub = localStorage.getItem("activeDigitalSub");

      // wait until value exists
      if (isDigitalSub !== null) {
        if (isDigitalSub === "false" && !window.__ADS_LOADED__) {
          console.log("Loading Ads Script");
          const s1 = document.createElement("script");
          s1.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
          s1.defer = true;
          document.head.appendChild(s1);

          window.__ADS_LOADED__ = true;
        }

        clearInterval(interval);
      }

      // safety exit
      attempts++;
      if (attempts > 20) clearInterval(interval);
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return null;
}

export default AdsBootstrapper;
